/** GPS collection is separate from permission to view somebody else's route. */
type GpsUser = { id: string; company_id?: string; company?: { enabled_modules?: { gps_tracking?: boolean } } } | null;
export const GPS_OPTIONAL_WARNING = 'GPS praćenje rute nije dostupno. Rad i obilaske možete normalno započeti i završiti.';
export function canUseGps(user: GpsUser, can?: (permission: string) => boolean): boolean {
  return Boolean(user?.company_id && user.company?.enabled_modules?.gps_tracking === true && can?.('gps.track'));
}
let scope: string | null = null;
let revision = 0;
const listeners = new Set<() => void>();
export function configureGpsAccess(user: GpsUser, granted: boolean): void {
  const next = user?.company_id && user.company?.enabled_modules?.gps_tracking === true && granted ? `${user.id}:${user.company_id}` : null;
  if (next === scope) return;
  scope = next; revision++;
  listeners.forEach(listener => listener());
}
export function gpsAccessSnapshot(): string | null { return scope ? `${scope}:${revision}` : null; }
export function isGpsAccessCurrent(snapshot: string | null): boolean { return Boolean(snapshot && snapshot === gpsAccessSnapshot()); }
export function onGpsAccessChange(listener: () => void): () => void { listeners.add(listener); return () => { listeners.delete(listener); }; }
